var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect2, _path16, _rect3, _path17, _g, _g2, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.787109,
    y: 0.53125,
    width: 350,
    height: 233,
    fill: "#E09064"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.674 147.156C213.674 143.843 216.36 141.156 219.674 141.156H225.046C228.36 141.156 231.046 143.843 231.046 147.156V155.283C231.046 158.597 228.36 161.283 225.046 161.283H219.674C216.36 161.283 213.674 158.597 213.674 155.283V147.156Z",
    fill: "#2C190E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M291.143 147.156C291.143 143.843 293.829 141.156 297.143 141.156H302.515C305.828 141.156 308.515 143.843 308.515 147.156V155.283C308.515 158.597 305.828 161.283 302.515 161.283H297.143C293.829 161.283 291.143 158.597 291.143 155.283V147.156Z",
    fill: "#2C190E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.649 79.5848C251.838 78.6516 252.658 77.9805 253.61 77.9805H269.049C270.001 77.9805 270.821 78.6516 271.009 79.5848L272.405 86.5H250.254L251.649 79.5848Z",
    fill: "#532626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.008 90.7901C223.536 87.948 226.016 85.8867 228.907 85.8867H293.278C296.169 85.8867 298.649 87.948 299.177 90.7901L305.097 122.632H217.088L223.008 90.7901Z",
    fill: "#389282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M305.097 122.632L299.178 90.7901C298.649 87.948 296.17 85.8867 293.279 85.8867H228.025L251.079 122.632H305.097Z",
    fill: "#246B5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.396 84.4521V79.9609H256.084C257.114 79.9609 257.663 80.5875 257.666 81.4497C257.663 82.3089 257.107 82.9323 256.071 82.9323H255.203V84.4521H254.396ZM255.203 82.2686H255.96C256.568 82.2655 256.841 81.9243 256.841 81.4497C256.841 80.969 256.568 80.6371 255.96 80.6371H255.203V82.2686Z",
    fill: "#913A3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M258.559 84.5017C258.292 84.5017 258.072 84.2846 258.075 84.0179C258.072 83.7573 258.292 83.5433 258.559 83.5402C258.816 83.5433 259.037 83.7573 259.037 84.0179C259.037 84.2846 258.816 84.5017 258.559 84.5017Z",
    fill: "#913A3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M259.837 84.4521V79.9609H261.524C262.554 79.9609 263.103 80.5875 263.106 81.4497C263.103 82.3089 262.548 82.9323 261.512 82.9323H260.643V84.4521H259.837ZM260.643 82.2686H261.4C262.008 82.2655 262.281 81.9243 262.281 81.4497C262.281 80.969 262.008 80.6371 261.4 80.6371H260.643V82.2686Z",
    fill: "#913A3A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M264.514 79.9609V84.4521H263.72V79.9609H264.514Z",
    fill: "#913A3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M266.766 84.5203C265.752 84.5203 265.128 83.8442 265.128 82.7896C265.128 81.7475 265.761 81.0403 266.722 81.0403C267.547 81.0403 268.261 81.5583 268.261 82.74V82.9881H265.91C265.922 83.5619 266.26 83.9031 266.772 83.9C267.119 83.9031 267.352 83.7542 267.454 83.5526H268.23C268.087 84.1357 267.547 84.5203 266.766 84.5203ZM265.913 82.4484H267.504C267.501 81.9894 267.191 81.6544 266.735 81.6544C266.26 81.6544 265.941 82.0204 265.913 82.4484Z",
    fill: "#913A3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M226.244 92.8178C226.594 90.9203 228.248 89.543 230.177 89.543H292.009C293.938 89.543 295.593 90.9203 295.942 92.8178L301.438 122.629H220.748L226.244 92.8178Z",
    fill: "#97BCB5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.438 122.629L295.942 92.8178C295.593 90.9203 293.938 89.543 292.009 89.543H230.307L251.762 122.629H301.438Z",
    fill: "#799993"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M217.088 122.633H305.097L312.416 130.103H209.77L217.088 122.633Z",
    fill: "#42AE9A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M209.77 130.102H312.416V142.21C312.416 147.732 307.939 152.21 302.416 152.21H219.77C214.247 152.21 209.77 147.732 209.77 142.21V130.102Z",
    fill: "#389281"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M312.415 142.21V130.102H228.48L256.883 152.21H302.415C307.938 152.21 312.415 147.732 312.415 142.21Z",
    fill: "#286559"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 244.385,
    y: 138.043,
    width: 33.8903,
    height: 10.0791,
    fill: "#532626"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M278.275 138.043H244.385V142.523L251.689 148.122H278.275V138.043Z",
    fill: "#3E1616"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 246.008,
    y: 139.621,
    width: 30.6426,
    height: 6.92286,
    fill: "#784444"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M276.65 139.621H246.008V143.757L249.752 146.544H276.65V139.621Z",
    fill: "#673737"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_569_27155)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 222.358,
    cy: 143.132,
    r: 4.99095,
    fill: "#532626"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_569_27155)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 299.827,
    cy: 143.132,
    r: 4.99095,
    fill: "#532626"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M254.396 145.296V140.805H256.084C257.114 140.805 257.663 141.431 257.666 142.293C257.663 143.153 257.107 143.776 256.071 143.776H255.203V145.296H254.396ZM255.203 143.112H255.96C256.568 143.109 256.841 142.768 256.841 142.293C256.841 141.813 256.568 141.481 255.96 141.481H255.203V143.112Z",
    fill: "#4B0F0F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M258.559 145.345C258.292 145.345 258.072 145.128 258.075 144.862C258.072 144.601 258.292 144.387 258.559 144.384C258.816 144.387 259.037 144.601 259.037 144.862C259.037 145.128 258.816 145.345 258.559 145.345Z",
    fill: "#4B0F0F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M259.837 145.296V140.805H261.524C262.554 140.805 263.103 141.431 263.106 142.293C263.103 143.153 262.548 143.776 261.512 143.776H260.643V145.296H259.837ZM260.643 143.112H261.4C262.008 143.109 262.281 142.768 262.281 142.293C262.281 141.813 262.008 141.481 261.4 141.481H260.643V143.112Z",
    fill: "#4B0F0F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M264.514 140.805V145.296H263.72V140.805H264.514Z",
    fill: "#4B0F0F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M266.766 145.364C265.752 145.364 265.128 144.688 265.128 143.633C265.128 142.591 265.761 141.884 266.722 141.884C267.547 141.884 268.261 142.402 268.261 143.584V143.832H265.91C265.922 144.406 266.26 144.747 266.772 144.744C267.119 144.747 267.352 144.598 267.454 144.396H268.23C268.087 144.979 267.547 145.364 266.766 145.364ZM265.913 143.292H267.504C267.501 142.833 267.191 142.498 266.735 142.498C266.26 142.498 265.941 142.864 265.913 143.292Z",
    fill: "#4B0F0F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M302.952 108.522C303.014 108.021 303.439 107.645 303.945 107.645H305.098L303.868 116.491L302.328 113.593L302.952 108.522Z",
    fill: "#246B5E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M303.713 107.645H307.672C309.034 107.645 310.138 108.748 310.138 110.11V110.11C310.138 111.471 309.034 112.575 307.672 112.575H303.713V107.645Z",
    fill: "#246B5E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M303.713 108.488C303.713 108.425 303.763 108.375 303.826 108.375H307.672C308.63 108.375 309.406 109.151 309.406 110.108V110.108C309.406 111.065 308.63 111.841 307.672 111.841H303.826C303.763 111.841 303.713 111.791 303.713 111.729V108.488Z",
    fill: "#799993"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M219.234 108.522C219.172 108.021 218.746 107.645 218.241 107.645H217.087L218.317 116.491L219.857 113.593L219.234 108.522Z",
    fill: "#389281"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M218.473 107.645H214.513C213.152 107.645 212.048 108.748 212.048 110.11V110.11C212.048 111.471 213.152 112.575 214.513 112.575H218.473V107.645Z",
    fill: "#389281"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M218.473 108.488C218.473 108.425 218.422 108.375 218.36 108.375H214.513C213.556 108.375 212.78 109.151 212.78 110.108V110.108C212.78 111.065 213.556 111.841 214.513 111.841H218.36C218.422 111.841 218.473 111.791 218.473 111.729V108.488Z",
    fill: "#97BCB5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_569_27155",
    x: 217.367,
    y: 138.141,
    width: 10.4824,
    height: 10.4805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.745833 0 0 0 0 0.279687 0 0 0 0 0.279687 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27155"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_569_27155",
    x: 294.836,
    y: 138.141,
    width: 10.4824,
    height: 10.4805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.745833 0 0 0 0 0.279687 0 0 0 0 0.279687 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27155"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport04);
export default __webpack_public_path__ + "static/media/transport_04.437d771fcb7ad16d5c5baa59143152d5.svg";
export { ForwardRef as ReactComponent };